import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

export interface DashboardSectionProps {
  title: ReactNode;
  description?: ReactNode;
  /** section-level action, right-aligned beside the title */
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  id?: string;
}

/** A dashboard section: a hairline, a title beside its action, then the work.
 *  Deliberately has no background, radius, or shadow - a box around every
 *  section is the grammar this replaces. */
export const DashboardSection = ({
  title,
  description,
  action,
  children,
  className,
  id,
}: DashboardSectionProps) => (
  <section id={id} className={cn('border-t border-rule pt-4', className)}>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0">
        <h2 className="text-16 font-medium text-text">{title}</h2>
        {description === undefined ? null : (
          <p className="mt-1 text-13 text-text-2">{description}</p>
        )}
      </div>
      {action === undefined ? null : (
        <div className="flex shrink-0 items-center gap-2">{action}</div>
      )}
    </div>
    <div className="mt-4">{children}</div>
  </section>
);
